import React from 'react';
import { Box, Container, Typography, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const Footer = () => {
  const theme = useTheme();
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <Box
      component="footer"
      sx={{
        py: 6,
        backgroundColor: theme.palette.primary.dark,
        color: 'white',
      }}
      ref={ref}
    >
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.6 }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 3,
              textAlign: 'center',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexWrap: 'wrap',
                gap: 2,
              }}
            >
              <Box
                component="img"
                src="/images/logo_w.svg"
                alt="ДокМедЧат"
                sx={{ height: 40 }}
              />
              <Typography
                className="MuiTypography-root MuiTypography-body2 pencil-text css-m8143"
                sx={{ opacity: 0.7, fontSize: '0.875rem', maxWidth: 700, textAlign: 'left' }}
              >
                Проект выполнен при поддержке "Фонда содействия инновациям" в рамках программы "Студенческий стартап" федерального проекта "Платформа университетского технологического предпринимательства"
              </Typography>
            </Box>
            <Box
              component="img"
              src="/images/univerpredprenimatelstvologo.png"
              alt="Логотип Платформы университетского технологического предпринимательства"
              sx={{
                height: { xs: 48, sm: 56 },
                maxWidth: '100%',
                objectFit: 'contain',
                backgroundColor: 'white',
                borderRadius: 1,
                px: 1.5,
                py: 0.5,
              }}
            />
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
};

export default Footer; 